// 18 Emotion Images for Stage 1 (3 variations each for 6 emotions)
export const emotionImagesData = [
  // Sad (IDs 4-6)
  { id: 4, emotion: 'Sad', image: '😢', imageSrc: 'https://images.pexels.com/photos/4584111/pexels-photo-4584111.jpeg' },
  { id: 5, emotion: 'Sad', image: '😔', imageSrc: 'https://images.pexels.com/photos/3905727/pexels-photo-3905727.jpeg' },
  { id: 6, emotion: 'Sad', image: '☹️', imageSrc: 'https://images.pexels.com/photos/7273347/pexels-photo-7273347.jpeg' },
  // Scared (IDs 10-12)
  { id: 10, emotion: 'Scared', image: '😨', imageSrc: 'https://images.pexels.com/photos/3812725/pexels-photo-3812725.jpeg' },
  { id: 11, emotion: 'Scared', image: '😱', imageSrc: 'https://images.pexels.com/photos/4681361/pexels-photo-4681361.jpeg' },
  { id: 12, emotion: 'Scared', image: '😰', imageSrc: 'https://images.pexels.com/photos/3907760/pexels-photo-3907760.jpeg'},
  // Happy (IDs 1-3)
  { id: 1, emotion: 'Happy', image: '😊', imageSrc: 'https://images.pexels.com/photos/4584532/pexels-photo-4584532.jpeg' },
  { id: 2, emotion: 'Happy', image: '😄', imageSrc: 'https://images.pexels.com/photos/7275812/pexels-photo-7275812.jpeg' },
  { id: 3, emotion: 'Happy', image: '😁', imageSrc: 'https://images.pexels.com/photos/6349131/pexels-photo-6349131.jpeg' },

  
  // Angry (IDs 7-9)
  { id: 7, emotion: 'Angry', image: '😠', imageSrc: 'https://images.pexels.com/photos/4923036/pexels-photo-4923036.jpeg' },
  { id: 8, emotion: 'Angry', image: '😡', imageSrc: 'https://images.pexels.com/photos/7670914/pexels-photo-7670914.jpeg' },
  { id: 9, emotion: 'Angry', image: '🤬', imageSrc: ' https://images.pexels.com/photos/7255381/pexels-photo-7255381.jpeg'},
  
  // Surprised (IDs 13-15)
  { id: 13, emotion: 'Surprised', image: '😮', imageSrc: 'https://images.pexels.com/photos/4584161/pexels-photo-4584161.jpeg'},
  { id: 14, emotion: 'Surprised', image: '😲', imageSrc: 'https://images.pexels.com/photos/7327762/pexels-photo-7327762.jpeg'},
  { id: 15, emotion: 'Surprised', image: '🤩', imageSrc: 'https://images.pexels.com/photos/8638027/pexels-photo-8638027.jpeg'},
  
  // Neutral (IDs 16-18)
  { id: 16, emotion: 'Neutral', image: '😐', imageSrc: 'https://images.pexels.com/photos/4584109/pexels-photo-4584109.jpeg' },
  { id: 17, emotion: 'Neutral', image: '😑', imageSrc: 'https://images.pexels.com/photos/7562180/pexels-photo-7562180.jpeg' },
  { id: 18, emotion: 'Neutral', image: '😶', imageSrc: 'https://images.pexels.com/photos/3234369/pexels-photo-3234369.jpeg' },
];

// Emotion options with styling for Stage 1 (6 emotions only)
export const emotionOptions = [
  { name: 'Happy',     emoji: '😊', bg: '#FFF9DB', border: '#FFE066', text: '#B7791F' },
  { name: 'Sad',       emoji: '😢', bg: '#EBF8FF', border: '#90CDF4', text: '#2B6CB0' },
  { name: 'Angry',     emoji: '😠', bg: '#FFF5F5', border: '#FEB2B2', text: '#C53030' },
  { name: 'Surprised', emoji: '😮', bg: '#F0FFF4', border: '#9AE6B4', text: '#276749' },
  { name: 'Scared',    emoji: '😨', bg: '#FAF5FF', border: '#D6BCFA', text: '#6B46C1' },
  { name: 'Neutral',   emoji: '😐', bg: '#FAFAFA', border: '#E2E8F0', text: '#4A5568' },
];

// 10 Questions for children (using only 6 emotions)
export const quizQuestions = [
  {
    id: 1,
    question: 'How does this face feel?',
    correctEmotion: 'Happy',
    options: ['Happy', 'Sad', 'Angry', 'Neutral'],
  },
  {
    id: 2,
    question: 'What emotion is this?',
    correctEmotion: 'Neutral',
    options: ['Happy', 'Sad', 'Scared', 'Neutral'],
  },
  {
    id: 3,
    question: 'Can you identify this emotion?',
    correctEmotion: 'Angry',
    options: ['Angry', 'Happy', 'Neutral', 'Scared'],
  },
  {
    id: 4,
    question: 'This face shows which feeling?',
    correctEmotion: 'Scared',
    options: ['Happy', 'Scared', 'Neutral', 'Sad'],
  },
  {
    id: 5,
    question: 'What is this emotion?',
    correctEmotion: 'Sad',
    options: ['Surprised', 'Angry', 'Sad', 'Neutral'],
  },
  {
    id: 6,
    question: 'How does this face feel?',
    correctEmotion: 'Surprised',
    options: ['Happy', 'Sad', 'Neutral', 'Surprised'],
  },
  {
    id: 7,
    question: 'Which emotion matches this face?',
    correctEmotion: 'Happy',
    options: ['Neutral', 'Surprised', 'Happy', 'Scared'],
  },
  {
    id: 8,
    question: 'What is this feeling?',
    correctEmotion: 'Angry',
    options: ['Scared', 'Angry', 'Sad', 'Surprised'],
  },
  {
    id: 9,
    question: 'This person is feeling...?',
    correctEmotion: 'Surprised',
    options: ['Surprised', 'Angry', 'Sad', 'Neutral'],
  },
  {
    id: 10,
    question: 'Can you name this emotion?',
    correctEmotion: 'Scared',
    options: ['Scared', 'Happy', 'Neutral', 'Angry'],
  },
];
